module.exports = __webpack_public_path__ + "img/yota-vitrina-5.dad18442.png";